import Alpine from "alpinejs";

interface IState {
    presentConsentModal: boolean,
    consentedServices: Array<string>,
    installedServices: Array<string>,
}
interface IConfig {
    urlStoreConsent: string,
    modalVersion: string,
    /**
     * key-value lookup between tracking-service-enum and name of loader-method 
     */
    loaderMethods: Object,
}
enum Action {
    consent_all = 'consent_all',
    consent_many = 'consent_many',
    consent = 'consent',
    reject_all = 'reject_all',
    reject = 'reject',
}

/**
 * client can pass in any uiState and use it accordingly
 */
Alpine.data('consentManagement', (state: IState, config: IConfig, uiState: Object = {}) => ({
    
    state: state as IState,
    config: config as IConfig,
    uiState: uiState as Object,
    
    init() {
        this.$watch('state.consentedServices', (value: Array<string>, valueBefore: Array<string>) => {
            value.forEach(service => {
                if(!valueBefore.includes(service)) {
                    const loaderName = this.config.loaderMethods[service];
                    if(typeof window[loaderName] === 'function') {
                        window[loaderName]()
                        delete window[loaderName]
                    }
                }
            })
        })
        this.$nextTick(() => {
            this.$dispatch('consent-initialized')
        })        
    },

    async store(action: Action, services: Array<string>) {
        return fetch(this.config.urlStoreConsent, {
            
            method: 'POST', 
            credentials: 'include', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                action: action,
                services: services,
                modalVersion: this.config.modalVersion,
            })
            
        }).then(response => {
            
            if(!response.ok) {
                throw new Error('response status '+response.status+'/'+response.statusText)
            }
            return response.json()
            
        }).then(data => {
            
            if(data.status === 'success') {
                this.state.consentedServices = data.consentedServices
                this.state.presentConsentModal = data.presentConsentModal
            }
            
        }).catch(err => {
            console.error(err)
        })
    },
    
    async consentAll() {
        this.$dispatch('consent-chosen', 'consent-all');
        return this.store(
            Action.consent_all,
            []
        )
    },
    
    async consentMany(services) {
        this.$dispatch('consent-chosen', 'consent-many');
        return this.store(
            Action.consent_many,
            services
        )
    },
    
    async consent(service) {
        return this.store(
            Action.consent,
            [ service ]
        )
    },

    async rejectAll() {
        this.$dispatch('consent-chosen', 'reject-all');
        return this.store(
            Action.reject_all,
            []
        )
    },

    async reject(service) {
        return this.store(
            Action.reject,
            [ service ]
        )
    },

    hasConsent(service) {
        return this.state.consentedServices.includes(service)
    },
    
}));